import type {PartValueRenderer} from 'schema/types';
import {useLocalization} from 'localization';
import {useTextValue} from 'schema/preview/hooks';

export const DateMultiple: PartValueRenderer = ({value, delimiter}) => {
  const TextValue = useTextValue();
  const {formatDate} = useLocalization();

  if (!Array.isArray(value)) {
    return <TextValue>{formatDate(value as string, 'short', false)}</TextValue>;
  }

  return (
    <>
      {value.map((v, i) => (
        <TextValue key={i}>
          {i !== 0 && (delimiter ?? ', ')}
          {formatDate(v as string, 'short', false)}
        </TextValue>
      ))}
    </>
  );
};
